import React from "react";
import { withStyles } from "@material-ui/core/styles";

import colors from "../../assets/style/colors";

const styles = {
  message: {
    color: colors.errorRed,
    margin: 0,
    fontSize: "0.875em"
  }
};

function IncorrectInputMessage(props) {
  return <p className={props.classes.message}>{props.message}</p>;
}

export default withStyles(styles)(IncorrectInputMessage);
